module.exports = __webpack_public_path__ + "img/empty.c124efaf.svg";